import { PUSH_FAVOURITE } from '../utils/actionTypes';

const initialState = {
  holidays: [],
  activities: [],
  accommodations: [],
};

const favouritesReducer = (state = initialState, { type, payload }) => {
  if (type === PUSH_FAVOURITE) {
    const { id, context } = payload;

    // if the favourite is present already - remove, otherwise add
    if (state[context].includes(id)) {
      // remove
      const newArray = state[context].filter((_id) => _id !== id);
      const newState = { ...state, [context]: newArray };

      return newState;
    } else {
      // add
      const newState = { ...state, [context]: [...state[context], id] };

      return newState;
    }
  }

  return state;
};

export default favouritesReducer;
